module.exports = __webpack_public_path__ + "static/img/aqzs02.e9b59c97.jpg";